import { Injectable } from '@angular/core';
import { ChartValue } from "../chart/chart-value.model";

@Injectable()
export class TopFillBySourceService {

    generateGroupedArray(chartValues: ChartValue[], stepValue: number): ChartValue[] {
        let index = 1;
        let temporary = new Array<ChartValue>();
        let groupedChartValues = new Array<any>();
        for (let item of chartValues) {
            temporary.push(item);
            if (index % stepValue == 0) {
                groupedChartValues.push(temporary);
                temporary = new Array<ChartValue>();
            }
            if (index >= chartValues.length && temporary.length > 0) {
                groupedChartValues.push(temporary);
            }
            index++;
        }
        return groupedChartValues;
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/topfillbysource/top-fill-by-source.service.ts